export const ADD_POLL = 'ADD_POLL'
export const SET_POLLS = 'SET_POLLS'
export const SET_POLL = 'SET_POLL'
export const REMOVE_POLL = 'REMOVE_POLL'
export const SET_POLL_RESULTS = 'SET_POLL_RESULTS'